<template lang="pug">
    r-form(
        loading-text='Cargando nota de credito...'
        ref='form'
        reset-text='restablecer'
        submit-text='guardar'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submitUpdate'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, RForm } from '@/components/reusable_components/next'
    //
    import PurchaseCreditNoteModel from '@/models/Purchase/PchPurchaseCreditNote'
    import PurchaseCreditNoteFields from '@/views/Purchase/PchPurchaseCreditNote/PchPurchaseCreditNoteFields'
    //
    import TranslatorService from '@/services/translator'
    //
    export default {
        name: 'purchase-credit-note-update',
        components: {
            RForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             * 
             */
            fieldsProps() {
                return {
                    document_type_title: this.fieldsVariant ? 'Documento: Nota de debito' : 'Documento: Factura de compra',
                    pch_provider_branch_offices: this.formData.pch_provider_branch_offices,
                    pch_provider_trigger: this.triggerProvider,
                }
            },

            /**
             *
             */
            formProps() {
                return {
                    editable: false,
                    fields: PurchaseCreditNoteFields(this.fieldsProps).variant(this.fieldsVariant),
                    loading: this.busy,
                    //switchEdit: true,
                    title: this.formTitle,
                }
            },

            /**
             * 
             */
            fieldsVariant() {
                return this.formData.document_type
            },

            /**
             * 
             */
            formTitle() {
                return `Nota de credito #${this.$route.params.id}`
            },
        },
        data() {
            return {
                busy: false,
                formData: {},
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(PurchaseCreditNoteModel, error.response.data))
            },

            /**
             * 
             */
            fetch() {
                return PurchaseCreditNoteModel.modeler().find(this.$route.params.id).then(this.setFormData)
            },

            /**
             * 
             */
            reset() {
                this.setBusy(true).then(this.fetch).then(this.setBusy)
            },

            /**
             * 
             */
            async setBusy(busy = false) {
                this.busy = busy
            },

            /**
             * 
             */
            setFormData(model) {
                this.formData = model.reset()
            },

            /**
             * 
             */
            submitUpdate() {
                return this.$refs.form
                    .setWait(true)
                    .then(this.toUpdate)
                    .catch(this.error)
                    .then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            successUpdate() {
                this.setSuccessSnackbar('Nota de credito actualizada exitosamente.')
            },

            /**
             *
             */
            toUpdate(model) {
                return model
                    .toUpdate()
                    .save()
                    .then(this.successUpdate)
                    .then(this.reset)
            },

            /**
             * 
             */
            triggerProvider(ctx) {
                this.formData.pch_provider_branch_offices = ctx
                    .getInput('pch_provider_id')
                    .getSelected()
                    .getProperty('branch_offices', [])
            }
        },
        mounted() {
            this.setTitleTopBar(this.formTitle).then(this.reset)
        },
    }
</script>